export const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export const deepClone = (value) => JSON.parse(JSON.stringify(value ?? {}));

export const isIsoString = (value) => {
  if (typeof value !== 'string') return false;
  const date = new Date(value);
  return !Number.isNaN(date.getTime()) && value.includes('T');
};

export const isValidDateString = (value) => {
  if (typeof value !== 'string') return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime());
};

export const formatDateString = (date = new Date()) => date.toISOString().split('T')[0];

export const isHexColor = (value) => typeof value === 'string' && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);

export const stableHash = (input) => {
  const str = String(input);
  let hash = 5381;
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash &= 0xffffffff;
  }
  return Math.abs(hash).toString(36);
};

export const titleFromSlideId = (slideId) => {
  if (!slideId) return 'Slide';
  return slideId
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const ensureArray = (value) => (Array.isArray(value) ? value : []);

